export class IbanUtils {
  static getCountry = (iban: string) => {
    if (iban.length < 2) return undefined;
    return iban.substring(0, 2);
  };
}
